"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationLink = exports.NotificationImageContainer = exports.PriceContainer = exports.NotificationContainer = exports.NotificationHeader = exports.NotificationsScrollable = exports.Notification = void 0;

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = require("@emotion/react");

var frontend_layout_1 = require("@ryerson/frontend.layout");

exports.Notification = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\twidth: 100%;\n\tborder-radius: 2px;\n\t", ";\n"])), function (props) {
  var bgColor = props.bgColor,
      borderColor = props.borderColor,
      isNative = props.isNative;
  return (0, react_1.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\tborder: 1px solid ", ";\n\t\t\tbackground: ", ";\n\t\t\tmargin-top: ", ";\n\t\t"])), borderColor, bgColor, isNative ? "calc(env(safe-area-inset-top) + 110px)" : "0");
});
exports.NotificationsScrollable = styled_1.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\toverflow-y: auto;\n\t", ";\n"])), function (props) {
  var isMobile = props.isMobile;
  return (0, react_1.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\t\tmax-height: ", ";\n\t\t"])), isMobile ? "30vh" : "380px");
});
exports.NotificationHeader = styled_1.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\tmax-width: 100%;\n\tpadding: 10px;\n\tp {\n\t\tmargin: 0;\n\t}\n\t", ";\n"])), function (props) {
  var bgColor = props.bgColor;
  return (0, react_1.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t\t\tbackground: ", ";\n\t\t"])), bgColor);
});
exports.NotificationContainer = (0, styled_1.default)(frontend_layout_1.Flex)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\tpadding: 0 20px;\n"])));
exports.PriceContainer = (0, styled_1.default)(frontend_layout_1.Flex)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\tpadding: 0 0 20px;\n"])));
exports.NotificationImageContainer = (0, styled_1.default)(frontend_layout_1.FlexItem)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\twidth: 25%;\n\tmargin: 0 20px 0 0;\n\t", ";\n"])), function (props) {
  var imageBorderColor = props.imageBorderColor;
  return (0, react_1.css)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n\t\t\timg {\n\t\t\t\tmargin: 15px auto 0;\n\t\t\t\tborder-radius: 2px;\n\t\t\t\tborder: 1px solid ", ";\n\t\t\t}\n\t\t"])), imageBorderColor);
});
exports.NotificationLink = styled_1.default.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\t", ";\n"])), function (props) {
  var color = props.color;
  return (0, react_1.css)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n\t\t\tcolor: ", ";\n\t\t"])), color);
});